export const contact = {
  title: 'Contattaci',
  subtitle: 'Mettiti in contatto con il nostro team',
  email: {
    abuse: {
      title: 'Abuse',
      address: 'abuse@synthohosting.net'
    },
    tech: {
      title: 'Supporto Tecnico',
      address: 'tech@synthohosting.net'
    },
    info: {
      title: 'Informazioni Generali',
      address: 'info@synthohosting.net'
    },
    admin: {
      title: 'Amministrazione',
      address: 'amministrativo@synthohosting.net'
    }
  },
  phone: {
    title: 'Telefono',
    number: '+39 0984 180 0706'
  },
  address: {
    title: 'Indirizzo',
    line1: 'Via Isonzo 102',
    line2: '73055 Racale (LE)',
    country: 'Italia'
  },
  company: {
    title: 'Informazioni Aziendali',
    name: 'MULTI SERVICE S.R.L.S.',
    vat: 'P.IVA / VAT.ID: IT 05316380756',
    rea: 'REA: LE - 358063'
  }
};